import service from '../providers/service.js';
import { tokenize } from "../helpers/token.js";
import { SET_ATTACHMENT, RESET_ATTACHMENTS, UNSET_ATTACHMENTS, UPDATE_ATTACHMENT } from "./types.js";
import { setErrors } from "./error.js";

// Create new attachment
export function createAttachment(attachment) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(attachment).forEach(k => {
      if (attachment[k]) {
        if (attachment[k].constructor === Array) {
          data.append(k, JSON.stringify(attachment[k]));
        } else {
          data.append(k, attachment[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/attachments`), data, config)
      .then(response => {
        if (response.data.message === 'attachment.success') {
          dispatch(setAttachment(response.data.attachment));
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// Update an attachment
export function updateAttachment(attachment) {
  return dispatch => {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };
    const data = new FormData();

    Object.keys(attachment).forEach(k => {
      if (attachment[k]) {
        if (attachment[k].constructor === Array) {
          data.append(k, JSON.stringify(attachment[k]));
        } else {
          data.append(k, attachment[k]);
        }
      }
    });

    service
      .post(tokenize(`/api/attachments/${attachment.id}`), data, config)
      .then(response => {
        if (response.data.message === 'attachment.success') {
          dispatch(updateAttachmentInStore(attachment));
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  };
}

// Delete attachments
export function deleteAttachments(attachmentIds) {
  return dispatch => {
    service
      .post(tokenize(`/api/attachments/destroy`), { ids: attachmentIds })
      .then(response => {
        if (response.data.message === 'attachment.success') {
          dispatch(unsetAttachments(attachmentIds));
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch(err => {
        console.log(err);
      })
  }
}

// set attachment to store
export function setAttachment(attachment) {
  return {
    type: SET_ATTACHMENT,
    attachment: attachment
  };
}

// unset attachment from store
export function unsetAttachments(attachments) {
  return {
    type: UNSET_ATTACHMENTS,
    attachments: attachments
  };
}

// update attachment in store
export function updateAttachmentInStore(attachment) {
  return {
    type: UPDATE_ATTACHMENT,
    attachment: attachment
  };
}

// reset attachments
export function resetAttachments() {
  return { type: RESET_ATTACHMENTS };
}


// WEBPACK FOOTER //
// ./src/actions/attachment.js